// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oZE0","colBig":"styles_colBig__1CqOZ","colSmall":"styles_colSmall__I3ODQ","shopifyNameWrapper":"styles_shopifyNameWrapper__2nMXr"};